import { zodResolver } from '@hookform/resolvers/zod'
import { CheckedAddress } from '@sparkdotfi/common-universal'
import { useState } from 'react'
import { UseFormReturn, useForm } from 'react-hook-form'
import { isAddress } from 'viem'
import { z } from 'zod'

export interface UseInputAddressExtensionResult {
  form: UseFormReturn<InputAddressExtensionForm>
  enabled: boolean
  setEnabled: (enabled: boolean) => void
  address: CheckedAddress | null
}

export function useInputAddressExtension(): UseInputAddressExtensionResult {
  const [enabled, setEnabled] = useState(false)

  const form = useForm<InputAddressExtensionForm>({
    resolver: zodResolver(inputAddressExtensionSchema),
    defaultValues: {
      address: '',
    },
    mode: 'onChange',
  })
  const { address } = form.watch()
  const inputValid = form.formState.isValid

  return {
    form,
    enabled,
    setEnabled,
    address: inputValid ? address : null,
  }
}

const inputAddressExtensionSchema = z
  .object({
    address: z.string(),
  })
  .superRefine((data, ctx) => {
    if (!isAddress(data.address, { strict: false })) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Invalid address',
        path: ['address'],
      })
    }
  })
  .transform((data) => ({ address: CheckedAddress(data.address.toLowerCase()) }))

export type InputAddressExtensionForm = z.infer<typeof inputAddressExtensionSchema>
